module.exports = __webpack_public_path__ + "img/mundo-tim.5e545a4f.jpg";